module.exports = __webpack_public_path__ + "static/media/bankDetailsGrey.aa7ae69e.svg";